import { useEffect, useRef } from 'preact/hooks';
import simplur from 'simplur';
import { LightLabsIcon } from './icons/LightLabsIcon';
import { RightArrow } from './icons/RightArrow';
import { useData } from './useData';
import { formatDate } from './utils/dates';
import { logger } from './utils/logger';
import { getSearchParam } from './utils/url-helpers';
import { WidgetDialog, WidgetDialogRef } from './WidgetDialog';
import { useConfigContext } from './ConfigContext';

export const Widget = () => {
  const { companyId } = useConfigContext();

  const { product, lastTestDate } = useData();

  const dialogRef = useRef<WidgetDialogRef>(null);

  useEffect(() => {
    if (product?.skus?.length && getSearchParam('ll-open')) {
      setTimeout(() => dialogRef.current?.open(), 1000);
    }
  }, [product]);

  if (!product?.skus?.length) {
    logger.info('No SKUs to render');
    return null;
  }

  return (
    <>
      <div part="widget" className="lightlabs-widget" onClick={() => dialogRef.current?.open()}>
        <a
          href={
            'https://lightlabs.com/?utm_medium=widget&utm_campaign=pip_logo_click' +
            `&utm_source=${window.location.hostname}` +
            `&utm_content=${companyId}_${product.id}`
          }
          target="_blank"
          rel="noopener"
          className="logo-link"
          onClick={(e) => e.stopPropagation()}
        >
          <LightLabsIcon part="logo" width={31} height={22} style={{ minWidth: 31 }} />
        </a>

        <div part="divider" className="divider" />

        <div part="text-col" className="text-col text-ellipsis">
          <div part="text-row" className="text-row">
            <p part="text-tested-by" className="text-tested-by text-ellipsis">
              Tested by Light Labs in
            </p>

            <div part="time-pill" className="time-pill">
              {lastTestDate ? formatDate(lastTestDate, { day: undefined, month: 'short' }) : ''}
            </div>
          </div>

          <div part="text-row" className="text-row">
            <p part="text-test-results" className="text-test-results text-ellipsis">
              {simplur`${product.analytesCount} substance[|s] tested for purity`}
            </p>

            <RightArrow />
          </div>
        </div>
      </div>

      <WidgetDialog ref={dialogRef} product={product} />
    </>
  );
};
